import { useEffect } from "react";
import { http, API } from "@/lib/api";

// Counts clicks ONLY on elements explicitly tagged with data-social-platform
// (the official Ananawi social profile links). Never the player/miniplayer or
// track/video links. Delegated capture listener so it fires before the link opens.
const PLATFORMS = ["youtube", "instagram", "tiktok"];

export const SocialTracker = () => {
  useEffect(() => {
    if (!API) return;
    const onClick = (e) => {
      const el = e.target?.closest?.("[data-social-platform]");
      if (!el) return;
      const platform = el.getAttribute("data-social-platform");
      if (!PLATFORMS.includes(platform)) return;
      http.post("/track/social", { platform }).catch(() => {});
    };
    document.addEventListener("click", onClick, true);
    return () => document.removeEventListener("click", onClick, true);
  }, []);
  return null;
};
